"use strict";

/* -----------------------------------
  MODULES
------------------------------------ */
import { WIN_WIDTH, SCROLL_TOP } from "./modules/_utils.js";
import copy from "./modules/copy.js";
window.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector('.l-alert')) {
    copy();
  }
});